import React from "react";
import { Popover } from "@material-ui/core";
// import DraggableDialogPaperComponent from "app/common/components/DraggableDialogPaperComponent";
import { inject, observer } from "mobx-react";
import Spinner from "react-spinkit";
import AddColumnForm from "./AddColumnForm";

function AddColumnPopup({ store }) {
  const {
    open,
    setOpen,
    anchorEl: dialogAnchorEl,
    saveColumn,
    column,
    getCommonColumnOptions,
    isLoading,
  } = store;
  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);
    if (column && column.column_type_id === "10" && column.options.is_user_type) {
      column.column_type_id = "10-1";
    }

  const handleSubmit = async (values) => {
    const resp = await saveColumn(values);
    if (!resp) {
      if (
        (values.column_type_id === 19 &&
          values.options.formula &&
          !values.options.formula_column) ||
        (values.column_type_id === 7 &&
          values.formula &&
          !values.options.formula_column)
      ) {
        store.setIsFormulaDataTypeOpen(true);
      }
      return false;
    }

    setOpen(null);
    return true;
  };

  const handleClose = () => {
    if (store.isFormulaDataTypeOpen === true) {
      store.setIsFormulaDataTypeOpen(false);
    }
    setOpen(false);
  };

  return (
    <Popover
      open={open}
      onClose={handleClose}
      anchorEl={dialogAnchorEl}
      // PaperComponent={DraggableDialogPaperComponent}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      // fullWidth
      // maxWidth="xs"
    >
      {isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 300,
            width: 300,
          }}
        >
          <Spinner name="line-scale" color="rgb(35, 127, 244)" />
        </div>
      ) : (
        <AddColumnForm
          column={column}
          handleSubmit={handleSubmit}
          handleClose={handleClose}
          getCommonColumnOptions={getCommonColumnOptions}
          store={store}
          forceUpdate={forceUpdate}
        />
      )}
    </Popover>
  );
}

export default inject(({ store: appStore }) => ({
  // store: appStore.addColumnStore,
}))(observer(AddColumnPopup));